import { z } from 'zod';

import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateLoanTransferDocumentsSideEffectContext = BaseLoanIdSideEffect.extend({
  isUpdate: z.boolean().optional(),
  regenerateDocuments: z
    .object({
      goodbye: z.boolean(),
      mortgagee: z.boolean(),
    })
    .optional(), // documents should only be regenerated if relevant updates were made (ie dont regenerate goodbye letter if mortgagee clause field was updated)
});

export const GenerateLoanTransferDocumentsSideEffect = GenerateLoanTransferDocumentsSideEffectContext.extend({
  type: z.literal('generateLoanTransferDocuments'),
});
export type GenerateLoanTransferDocumentsSideEffect = z.infer<typeof GenerateLoanTransferDocumentsSideEffect>;
